import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-[var(--dark)] text-gray-300 pt-12 pb-8">
      <div className="container mx-auto px-4">
        <div className="mb-8">
          <div>
            <h3 className="text-xl font-bold text-white mb-4 flex items-center">
              <i className="fa-solid fa-robot mr-2 text-[var(--accent)]"></i>
              AI Tools Hub
            </h3>
            <p className="mb-4">
              The most comprehensive directory of AI tools for professionals and enthusiasts.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="hover:text-[var(--accent)] transition-colors">
                <i className="fa-brands fa-twitter text-lg"></i>
              </a>
              <a href="#" className="hover:text-[var(--accent)] transition-colors">
                <i className="fa-brands fa-linkedin text-lg"></i>
              </a>
              <a href="#" className="hover:text-[var(--accent)] transition-colors">
                <i className="fa-brands fa-github text-lg"></i>
              </a>
            </div>
          </div>
        </div>
        
        <div className="border-t border-gray-700 pt-6 text-sm">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p>© 2025 AI Tools Hub. All rights reserved.</p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link to="/privacy" className="hover:text-[var(--accent)] transition-colors">Privacy Policy</Link>
              <Link to="/terms" className="hover:text-[var(--accent)] transition-colors">Terms of Service</Link>
              <Link to="/about" className="hover:text-[var(--accent)] transition-colors">About Us</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}